class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.form = this.querySelector('.searchForm');
    console.log(this.form);
    this.bindEvents();
  }

  bindEvents(){
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 100).bind(this));
    this.input.addEventListener('focus', (event) => this.onFocus(event));
    document.addEventListener('click', (event) => {
      if (event.target.closest('.searchForm') !== this.form) {
        this.close(event)
      }
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }
  onFocus() {
    if (this.input.value.length > 0) {
      this.open();
    }
    else {
      this.close();
    }
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[limit]=100&resources[limit_scope]=each`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    console.log("CLOSE");
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);